import { render, staticRenderFns } from "./ShippingStep.vue?vue&type=template&id=a0b8ae60&scoped=true&lang=pug"
import script from "./ShippingStep.vue?vue&type=script&lang=js"
export * from "./ShippingStep.vue?vue&type=script&lang=js"
import style0 from "./ShippingStep.vue?vue&type=style&index=0&id=a0b8ae60&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b8ae60",
  null
  
)

export default component.exports